import React from 'react'
import Slider from 'react-slick'
import { Card, Icon, Button } from 'semantic-ui-react'
import ButtonAction from './Button';
import arrow_right from '../../img/send-message-btn-mobile.png'
import arrow_left from '../../img/send-message-btn-mobile-left.png'

function SampleNextArrow(props) {
  const { className, style, onClick } = props
  return (
    <div
      className={className}
      style={{
        ...style,
        display: 'block',
        zIndex: '10',
        right: '0',
        backgroundImage: `url(${arrow_right})`
      }}
      onClick={onClick}
    />
  )
}

function SamplePrevArrow(props) {
  const { className, style, onClick } = props
  return (
    <div
      className={className}
      style={{
        ...style,
        display: 'block',
        zIndex: '10',
        left: '0',
        backgroundImage: `url(${arrow_left})`
      }}
      onClick={onClick}
    />
  )
}

function computeButtons(buttons) {
  return (
    <Button.Group basic >
      {
        buttons.map((button, i) => (
          <ButtonAction
            button={button.data}
            key={i}
          />
        ),
        )
      }
    </Button.Group>
  )
}

const header = title => (
  <h3>
    <Icon circular inverted color='blabla' size="small" name="info" />
    {title}
  </h3>
)



function CarouselInfoMessage({ message }) {
  const settings = {
    speed: 500,
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
    infinite: false,
    slidesToScroll: 1,
    // useCSS: true,
    variableWidth: true,
    responsive: [
      {
        breakpoint: 990,
        settings: {
          slidesToShow: 1,
        }
      },
      {
        breakpoint: 1000000,
        settings: {
          slidesToShow: 1,
        },
      }]
  }
  return (
    <Slider
      {...settings}
    >
      {message.map((attachment, i) => {
        const {
          title,
          description = '',
          buttons = null,
        } = attachment.content
        return (
          <div
            key={i}
          >
            <Card
              header={header(title)}
              description={description.split('\n').map((item, key) => <span key={key}>{item}<br /></span>)}
              extra={buttons && computeButtons(buttons)}
            />
          </div>
        )
      })
      }
    </Slider>
  )
}

export default CarouselInfoMessage



// WEBPACK FOOTER //
// ./src/views/components/CarouselInfoMessage.js